import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.policies', {
        component: 'policies',
        redirectTo: 'company.policies.password-authentication-policy',
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/policies/policies.state.js